import React, { useMemo } from 'react'
import {
  Box,
  IcoMoon,
  Text,
  useResponsiveWrapperContext,
  CloseIcon,
} from '@usap/uicomponents'

const RemoveButton = props => {
  const {
    index,
    removeItemHandler,
  } = props

  const { isDesktop } = useResponsiveWrapperContext()

  const style = useMemo(
    () => ({
      wrapperAlignSelf: isDesktop === true ? 'end' : 'start',
      wrapperMargin: { top: 'medium' },
      iconMarginLeft: { marginLeft: '-3px' },
      iconSize: isDesktop === true ? '24px' : '16px',
    }),
    [isDesktop],
  )

  return (
    <Box
      direction="row"
      align="center"
      gap="small"
      id={`deleteItem${index}`}
      alignSelf={style.wrapperAlignSelf}
      margin={style.wrapperMargin}
      onClick={removeItemHandler}
    >
      <IcoMoon
        icon={CloseIcon}
        color="dark-1"
        style={style.iconMarginLeft}
        size={style.iconSize}
      />
      {isDesktop === false && (
        <Text
          size="small"
          color="blueLink"
          textAlign="center"
        >
          Remove
        </Text>
      )}
    </Box>
  )
}

export default RemoveButton
